module.exports = __webpack_public_path__ + "static/media/tiptransporte.97fedfd2.svg";